import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { DocumentSharePayload } from 'Interfaces/Document';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: DocumentSharePayload) =>
    $actions.documentSign.shareDocument(dispatch, payload),
  );
};
